import { APP_ROUTES } from "@/routers/routes";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";

import DashboardLayout from "@/layouts/dashboard-layout";
import UploadDetail from "@/partial/upload/detail";
import NewUpload from "@/partial/upload/new";
import RequireAuth from "@/routers/RequireAuth";
import CampaignPage from "../campaign";
import CreateCampaignPage from "../campaign/create-campaign";
import EditCampaignPage from "../campaign/edit-campaign";
import TemplatePage from "../template";
import CreateTemplatePage from "../template/create-template";
import EditTemplatePage from "../template/edit-template";
import UploadPage from "../upload";

const configAuthRoutes: RouteObject[] = [
  {
    // path: "*",
    element: (
      <RequireAuth redirectTo={APP_ROUTES.ACCESS_DENIED.to}>
        <DashboardLayout />
      </RequireAuth>
    ),
    children: [
      {
        index: true,
        element: <UploadPage />,
      },
      {
        path: "/upload",
        element: <UploadPage />,
      },
      {
        path: "/upload/:id",
        element: <UploadDetail />,
      },
      {
        path: "/upload/new",
        element: <NewUpload />,
      },
      {
        path: "/templates",
        element: <TemplatePage />,
      },
      {
        path: "/campaigns",
        element: <CampaignPage />,
      },
      {
        path: "/campaigns/:id",
        element: <EditCampaignPage />,
      },
      {
        path: "/campaigns/create",
        element: <CreateCampaignPage />,
      },
      {
        path: "/templates/edit/:id",
        element: <EditTemplatePage />,
      },
      {
        path: "/templates/create",
        element: <CreateTemplatePage />,
      },
      {
        path: "*",
        element: <Navigate to={APP_ROUTES.NOT_FOUND.to} replace />,
      },
    ],
  },
];
function DashboardPage() {
  return useRoutes(configAuthRoutes);
}

export default DashboardPage;
